import {Flex} from "antd"
import {useEffect, useState} from "react";
import {translations} from "./Translations";
import {ContactModal} from "./ContactModal";
import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";

const langs = [
    {code: "en", label: "English"},
    {code: "he", label: "עברית"},
    {code: "ru", label: "Русский"},
]

const LANG_CODES = langs.map(l => l.code);
const COOKIE_NAME = 'lang';
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year

const detectBrowserLang = (): string => {
    const browserLang = navigator.language.slice(0, 2).toLowerCase();
    return LANG_CODES.includes(browserLang) ? browserLang : 'en';
};

export const getLangFromUrl = () => {
    const parts = window.location.pathname.split("/");
    const part = parts[1]
    if (!langs.map((l) => l.code).includes(part)) return "en";
    return part || "en";
};
export const Header = ({ noRedirect = false }: { noRedirect?: boolean }) => {
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies([COOKIE_NAME]);
    const [contactOpen, setContactOpen] = useState(false);
    const [open, setOpen] = useState(false);

    const lang = getLangFromUrl();
    // @ts-ignore
    const t = translations[lang] || translations.en;

    // On mount: redirect to the right language and keep cookie in sync
    useEffect(() => {
        if (noRedirect) return;
        const urlPart = window.location.pathname.split('/')[1];
        const hasLangInUrl = LANG_CODES.includes(urlPart);

        if (!hasLangInUrl) {
            const saved = cookies[COOKIE_NAME];
            const resolved = (saved && LANG_CODES.includes(saved)) ? saved : detectBrowserLang();
            setCookie(COOKIE_NAME, resolved, {path: '/', maxAge: COOKIE_MAX_AGE});
            navigate(`/${resolved}/`, {replace: true});
        } else {
            // URL already has a valid lang — persist it
            setCookie(COOKIE_NAME, urlPart, {path: '/', maxAge: COOKIE_MAX_AGE});
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const changeLang = (l: string) => {
        setCookie(COOKIE_NAME, l, {path: '/', maxAge: COOKIE_MAX_AGE});
        const parts = window.location.pathname.split('/').filter(Boolean);
        const hasLang = LANG_CODES.includes(parts[0]);
        const rest = hasLang ? parts.slice(1) : parts;
        navigate(`/${l}/${rest.join('/')}`);
        setOpen(false);
    };

    return (
        <>
            <div className="header-wrapper">
                <div className="header">
                    <div className="brand" onClick={() => navigate(lang ? `/${lang}/` : "/")}
                         style={{cursor: 'pointer'}}>
                        <div className="brand-mark">
                            <img src={"/logo192.png"} alt="UGAR STUDIO logo"/>
                        </div>
                        <div>
                            <div className="brand-title"
                               style={{letterSpacing: 0, color: "#444444", fontWeight: 700, lineHeight: "14px"}}>
                                <div style={{fontSize: 16}}>UGAR</div>
                                <div style={{fontSize: 12}}>STUDIO</div>
                                <div style={{fontWeight: 300, fontSize: 13}}>GAMES</div>
                            </div>
                        </div>
                    </div>
                    <Flex className={"header-menu"} gap={10} align={'center'} dir={lang === 'he' ? 'rtl' : 'ltr'} style={{margin: "0 6px"}}>
                        <div className={`lang ${open ? 'open' : ''}`}>
                            <button className="lang-btn" onClick={() => setOpen(!open)}
                                    style={{whiteSpace: 'nowrap'}}>
                                {lang.toUpperCase()} ▾
                            </button>
                            <div className="lang-menu">
                                <button onClick={() => changeLang('en')}>English</button>
                                <button onClick={() => changeLang('he')}>עברית</button>
                                <button onClick={() => changeLang('ru')}>Русский</button>
                            </div>
                        </div>
                        <button className="button button-contact" onClick={
                            () => setContactOpen(true)
                        }>{t.contact}</button>
                    </Flex>
                </div>
            </div>
            <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} t={t} lang={lang}/>
        </ >
    )
}